import { Media } from 'components/core/BreakpointMedia'
import DesktopSkeleton from './DesktopSkeleton'
import MobileSkeleton from './MobileSkeleton'

const StoreSkeleton = () => {
  return (
    <>
      <Media greaterThanOrEqual="medium">
        <DesktopSkeleton />
      </Media>
      <Media lessThan="medium">
        <MobileSkeleton />
      </Media>
    </>
  )
}

export default StoreSkeleton
